import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { INSIDER_THRESHOLD_WAIVING_EXPERIMENT_END_DATE } from "@faire/web-api--source/indigofair/settings/INSIDER_THRESHOLD_WAIVING_EXPERIMENT_END_DATE";

export const useSettingInsiderWaiveThresholdsEndDate = (): string =>
  useSetting(INSIDER_THRESHOLD_WAIVING_EXPERIMENT_END_DATE, "0");
